import TaskList from '@/pages/task-list/TaskList';

export default TaskList;
